import { useNavigate } from "react-router-dom";
import { adminPrimaryButtonClass, adminSecondaryButtonClass } from "./adminStyles";

type AdminFormActionsProps = {
  listRoute: string;
  saving?: boolean;
  saveLabel?: string;
  cancelLabel?: string;
};

export default function AdminFormActions({
  listRoute,
  saving = false,
  saveLabel = "Save",
  cancelLabel = "Cancel",
}: AdminFormActionsProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap justify-end gap-3 border-t border-gray-200 pt-6 dark:border-gray-800">
      <button type="button" onClick={() => navigate(listRoute)} className={adminSecondaryButtonClass}>
        {cancelLabel}
      </button>
      <button type="submit" disabled={saving} className={adminPrimaryButtonClass}>
        {saving ? "Saving..." : saveLabel}
      </button>
    </div>
  );
}
